import { createMountsTreviDividerConfig } from "../../base";
import { IComponentConfig } from "@/app/@types/base-component";
import { Partition } from "@/app/domain/entities/partition";
import { MountsService } from "@/app/services/mounts.service";

const createNoDoorsMountsTreviFrameConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const totalHeight = MountsService.getTotalHeight(partition);

    const qty = Math.round(totalWidth * totalHeight) || 0;

    return createMountsTreviDividerConfig().qty(0).area(qty).build();
};

export const TreviNoDoorsConfigs = (partition: Partition) => [
    createNoDoorsMountsTreviFrameConfig(partition),
];
